import { MediaViewerPage } from '@jarvis/platform-ui';

export function VideoViewerPage() {
  return (
    <MediaViewerPage
      kind="video"
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
